export default __webpack_public_path__ + "static/media/ceramol-iage-eye-cream.a11ed27f.png";